import { clientSafeMessage } from "utils/clientSafeMessage";

export const CREDENTIALS_ERROR_TEXT =
  "Account Number, Server, or Password is incorrect. Please verify your trading account credentials.";

/**
 * Maps broker credential failures to a fixed client message; otherwise sanitizes API text.
 */
function isTradingCredentialApiMessage(m) {
  if (/invalid user or password|sign[- ]?in|user or e-mail/i.test(m)) {
    return false;
  }
  if (
    m.includes("failed to save expiry record") ||
    m.includes("account number") ||
    m.includes("trading password") ||
    m.includes("trade copier") ||
    m.includes("mt4") ||
    m.includes("mt5")
  ) {
    return true;
  }
  if (m.includes("invalid") && m.includes("server")) return true;
  if (
    m.includes("invalid") &&
    (m.includes("password") || m.includes("login") || m.includes("credential")) &&
    (m.includes("broker") || m.includes("server") || m.includes("account"))
  ) {
    return true;
  }
  if (m.includes("does not exist") && (m.includes("symbol") || m.includes("server"))) {
    return true;
  }
  if (m.includes("not updated") && m.includes("account")) return true;
  return false;
}

export function toCredentialMessage(apiMessage, fallback = CREDENTIALS_ERROR_TEXT) {
  const m = String(apiMessage || "").toLowerCase();
  if (
    /scheduleSlaveConnectSetup|is not defined|\bslave\b|\bmaster\b|duplikium/i.test(
      m,
    )
  ) {
    return clientSafeMessage(apiMessage, fallback);
  }
  if (isTradingCredentialApiMessage(m)) {
    return CREDENTIALS_ERROR_TEXT;
  }
  return clientSafeMessage(apiMessage, fallback);
}

/** Hints shown under account status — never pass through vendor/stack names. */
export function normalizeCredentialsHint(hint) {
  if (hint == null || hint === "") return null;
  const s = String(hint).trim();
  if (/identifiants|erron[eé]s|veuillez/i.test(s)) {
    return CREDENTIALS_ERROR_TEXT;
  }
  return clientSafeMessage(s, CREDENTIALS_ERROR_TEXT);
}
